var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Link as ReactRouterLink, NavLink as ReactRouterNavLink } from 'react-router-dom';
import { themeLss } from "../../lss";
import styled from "../../styled";
import { isUrlAbsolute } from "../../utils";
var linkSystem = themeLss({
    ':not([href]):not([tabindex])': {
        color: function (_a) {
            var lss = _a.lss;
            return lss.color;
        }
    },
    ':hover': {
        color: function (_a) {
            var lss = _a.lss;
            return lss.color;
        }
    },
    ':active': {
        color: function (_a) {
            var lss = _a.lss;
            return lss.color;
        }
    },
    ':visited': {
        color: function (_a) {
            var lss = _a.lss;
            return lss.color;
        }
    }
});
var cleanLinkProps = function (Component
// eslint-disable-next-line
) { return function (_a) {
    var lss = _a.lss, props = __rest(_a, ["lss"]);
    return React.createElement(Component, __assign({}, props));
}; };
export var Anchor = styled.a(linkSystem);
export var StyledLink = styled(cleanLinkProps(ReactRouterLink))(linkSystem);
export var StyledNavLink = styled(cleanLinkProps(ReactRouterNavLink))(linkSystem);
export function NavLink(_a) {
    var to = _a.to, props = __rest(_a, ["to"]);
    if (typeof to === 'string' && isUrlAbsolute(to)) {
        return React.createElement(Anchor, __assign({}, props, { href: to }));
    }
    return React.createElement(StyledNavLink, __assign({}, props, { to: to }));
}
export function Link(_a) {
    var to = _a.to, props = __rest(_a, ["to"]);
    if (typeof to === 'string' && isUrlAbsolute(to)) {
        return React.createElement(Anchor, __assign({}, props, { href: to }));
    }
    return React.createElement(StyledLink, __assign({}, props, { to: to }));
}
//# sourceMappingURL=Link.js.map